"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferHost = exports.isRunningOnCloudfront = exports.isRunningOnStaging = exports.isRunningOnBSLocal = exports.isRunningOnDevEnv = exports.isSecproxyDomain = exports.isProdMesh = exports.isProd = exports.isRunningOnServer = exports.Host = void 0;
const browser_accessors_1 = require("./lib/browser-accessors");
var Host;
(function (Host) {
    Host["LOCALHOST"] = "LOCALHOST";
    Host["SERVER"] = "SERVER";
    Host["LENS"] = "LENS";
    Host["STORY"] = "STORY";
    Host["STAGING"] = "STAGING";
    Host["SECPROXY"] = "SECPROXY";
    Host["BSLOCAL"] = "BSLOCAL";
    Host["CLOUDFRONT"] = "CLOUDFRONT";
    Host["PROD_MESH"] = "PROD_MESH";
    Host["UNKNOWN"] = "UNKNOWN";
})(Host = exports.Host || (exports.Host = {}));
function isRunningOnServer() {
    // https://github.com/vercel/next.js/issues/5354#issuecomment-520305040
    // eslint-disable-next-line no-restricted-globals -- getWindow() uses isRunningOnServer, so using that here will lead to a circular dependency
    return typeof window === "undefined";
}
exports.isRunningOnServer = isRunningOnServer;
function isProd() {
    if (isRunningOnServer()) {
        return process.env.STAGE === "production";
    }
    return (0, browser_accessors_1.getWindow)()?.location.hostname.endsWith(".snapchat.com") || false;
}
exports.isProd = isProd;
function isProdMesh() {
    return inferHost() === Host.PROD_MESH;
}
exports.isProdMesh = isProdMesh;
function isSecproxyDomain() {
    return inferHost() === Host.SECPROXY;
}
exports.isSecproxyDomain = isSecproxyDomain;
function isRunningOnDevEnv() {
    return inferHost() === Host.LOCALHOST;
}
exports.isRunningOnDevEnv = isRunningOnDevEnv;
function isRunningOnBSLocal() {
    return inferHost() === Host.BSLOCAL;
}
exports.isRunningOnBSLocal = isRunningOnBSLocal;
function isRunningOnStaging() {
    return inferHost() === Host.STAGING;
}
exports.isRunningOnStaging = isRunningOnStaging;
function isRunningOnCloudfront() {
    return inferHost() === Host.CLOUDFRONT;
}
exports.isRunningOnCloudfront = isRunningOnCloudfront;
/**
 * Infer host from page URL.
 * This only works on the client side, SSR always returns Host.SERVER.
 */
function inferHost() {
    if (isRunningOnServer()) {
        return Host.SERVER;
    }
    const host = (0, browser_accessors_1.getWindow)()?.document.location.host || "";
    if (host.includes("localhost")) {
        return Host.LOCALHOST;
    }
    else if (host.includes("sc-jpl.com") || host.includes("snap-dev.net")) {
        // https://webmap-ci.sc-jpl.com/ is map's staging server
        // Readme: https://github.sc-corp.net/Snapchat/hudson#quick-links
        return Host.STAGING;
    }
    else if (host.includes("lens.snapchat.com")) {
        return Host.LENS;
    }
    else if (host.includes("story.snapchat.com")) {
        return Host.STORY;
    }
    else if (!host.includes("staging") && host.includes("sc-corp.net")) {
        // e.g. https://web-accounts.mesh.sc-corp.net/ is prod mesh that uses prod users' pool
        return Host.PROD_MESH;
    }
    else if (host.endsWith(".sc-corp.net")) {
        return Host.SECPROXY;
    }
    else if (host.includes("bs-local.com")) {
        return Host.BSLOCAL;
    }
    else if (host.includes("cloudfront.net")) {
        return Host.CLOUDFRONT;
    }
    else {
        return Host.UNKNOWN;
    }
}
exports.inferHost = inferHost;
//# sourceMappingURL=utils.js.map